import { Locale } from 'antd-mobile/es/locales/base';

export enum LOCALES_KEYS {
    EN_US = 'en-US',
    ZH_CN = 'zh-CN'
}

export interface LocaleResponse {
    localeData: PlainObject;
    antdLocaleData: Locale;
}

export const SUPPOER_LOCALES = [
    {
        name: 'ENGLISH',
        value: LOCALES_KEYS.EN_US
    },
    {
        name: '简体中文',
        value: LOCALES_KEYS.ZH_CN
    }
];

export function getLocaleLoader(locale: LOCALES_KEYS): Promise<LocaleResponse> {
    switch (locale) {
        case LOCALES_KEYS.EN_US:
            return new Promise(async resolve => {
                const loc = await import(/* webpackChunkName: "en-US" */ './en_US.json').then(m => m.default);
                const antdLoc = await import(/* webpackChunkName: "antd-en-US" */ 'antd-mobile/es/locales/en-US').then(
                    m => m.default
                );
                resolve({ localeData: loc, antdLocaleData: antdLoc });
            });
        case LOCALES_KEYS.ZH_CN:
            return new Promise(async resolve => {
                const loc = await import(/* webpackChunkName: "zh-CN" */ './zh_CN.json').then(m => m.default);
                const antdLoc = await import(/* webpackChunkName: "antd-zh-CN" */ 'antd-mobile/es/locales/zh-CN').then(
                    m => m.default
                );
                resolve({ localeData: loc, antdLocaleData: antdLoc });
            });
        default:
            return new Promise(async resolve => {
                const loc = await import(/* webpackChunkName: "zh-CN" */ './zh_CN.json').then(m => m.default);
                const antdLoc = await import(/* webpackChunkName: "antd-zh-CN" */ 'antd-mobile/es/locales/zh-CN').then(
                    m => m.default
                );
                resolve({ localeData: loc, antdLocaleData: antdLoc });
            });
    }
}
